// @ts-nocheck
const env = window.env;
export default env